export default "__VITE_ASSET__rGQtB581__"